import React from 'react';
import { Box } from '@mantine/core';
import CurrencyInput from '../../../common/CurrencyInput';
import { BaseFieldProps } from './types';

export function MoneyField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  form,
  formFieldName,
  variant,
  fieldName,
  onChange,
}: BaseFieldProps<T>) {
  if (entityMetadata.type !== 'MONEY') {
    return null;
  }

  const currencySymbol = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: entityMetadata.currency,
    maximumSignificantDigits: 1,
  }).formatToParts(0)[0].value;

  const inputProps = form.getInputProps(formFieldName);

  return (
    <Box>
      <CurrencyInput
        id={formFieldName}
        required={!entityMetadata.isOptional}
        key={form.key(formFieldName)}
        label={fieldLabel}
        labelProps={{ variant: 'light' }}
        disabled={disabled}
        leftSection={currencySymbol}
        {...inputProps}
        variant={variant}
        onChange={value => onChange(value, fieldName)}
      />
    </Box>
  );
}
